"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Effects = /** @class */ (function () {
    function Effects(documentObject) {
        var _this = this;
        this.documentObject = documentObject;
        if (this.documentObject) {
            // All elements with effects 
            var effectElements_1 = documentObject.querySelectorAll('.js-effect, .block');
            var scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
            // Add initial value when page is loaded
            this.setElementScrolledIntoView(effectElements_1, scrollTop);
            document.addEventListener('scroll', function () {
                scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
                _this.setElementScrolledIntoView(effectElements_1, scrollTop);
            });
            document.body.addEventListener('scroll', function () {
                scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
                _this.setElementScrolledIntoView(effectElements_1, scrollTop);
            });
        }
    }
    // Set class depending if element is in view or not
    Effects.prototype.setElementScrolledIntoView = function (effectElements, scrolledTop) {
        var _this = this;
        var windowHeight = window.innerHeight;
        // Check each element
        effectElements.forEach(function (effectElement) {
            // Elements position
            var position = _this.offset(effectElement).top;
            // Add is-scrolled-into-view if element is on screen with 100px from bottom
            if ((scrolledTop + windowHeight) > (position)) {
                effectElement.classList.add('is-scrolled-into-view');
            }
            else {
                //effectElement.classList.remove('is-scrolled-into-view');
            }
        });
    };
    Effects.prototype.offset = function (el) {
        var top = 0;
        var left = 0;
        var element = el;
        // Loop through the DOM tree
        // and add it's parent's offset to get page offset
        do {
            top += element.offsetTop || 0;
            left += element.offsetLeft || 0;
            element = element.offsetParent;
        } while (element);
        return {
            top: top,
            left: left,
        };
    };
    return Effects;
}());
exports.default = Effects;
